import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Button } from '@src/elements/button/button'
import { H6 } from '@src/elements/typography/typography'
import { API } from '@src/lib/api_path'
import ApiClient from '@src/lib/api_client'
import { Input } from '@src/elements/input/input'
import EventBus from '@src/lib/event_bus'
import { ContentBox } from '@src/elements/content-box/content-box'
import { Modal } from '@src/elements/modal/modal'
import { InputFootnote } from '@src/elements/input/input-footnote'
import { Logo } from '@src/elements/logo/logo'
import QrcodeVue from 'qrcode.vue'
import { Spacer } from '@src/elements/spacer/spacer'

@Component({
  computed: {
    codeSerial () {
      return this.$store.state.selectedMember.codeSerial || ''
    },
    codeNumber () {
      return this.$store.state.selectedMember.codeNumber || ''
    }
  }
})
export default class QrCode extends Vue {

  protected codeSerial: string
  protected codeNumber: string
  private currentQrCode: string = ''
  private isQrFormVisible: boolean = false

  private apiClient: ApiClient = new ApiClient()
  private codeError: boolean = false

  constructor () {
    super()
  }

  showHideCodeForm () {
    this.isQrFormVisible = !this.isQrFormVisible
    this.currentQrCode = ''
    this.codeError = false
  }

  assign () {
    return this.apiClient.post(API.TRAINERS_API.MEMBER_ACTIVATE.replace('{memberId}', this.$route.params.id).replace('{codeSerial}', this.currentQrCode.trim()), {})
      .then(() => {
        this.$store.dispatch('showToast', { message: this.$t('PAGE.MEMBERS.QR_CODE.SAVED'), fadeOut: true })
        EventBus.trigger('reloadSelectedMember')
        this.showHideCodeForm()
      })
      .catch((error) => {
        this.codeError = true
        console.log('cannot activate new qr code to member', error)
      })
  }

  printQR () {
    window.print()
  }

  render (h: CreateElement) {
    return <div class='qr-code'>

      <ContentBox>
        <div slot='content'>
          {this.codeSerial ?
            <div class='member-qr'>
              <Logo />
              <H6>{this.codeSerial}</H6>
              <Spacer />
              <QrcodeVue value={this.codeNumber} size={200} class='generated-qr-code' />
            </div> : null}
        </div>

        {this.renderActionButtons(h)}
      </ContentBox>

      <Modal show={this.isQrFormVisible}
             closeCallback={this.showHideCodeForm}
             cssClass='reactivation-qr-code'
             title={this.$t('PAGE.MEMBERS.QR_CODE.ASSIGN')}>
        <div>
          <Input ref='qrInput' class={this.codeError ? 'error' : ''} value={this.currentQrCode} placeholder={this.$t('QR_CODE')} valueChanged={(value) => this.currentQrCode = value}
                 label={this.$t('PAGE.MEMBERS.QR_CODE.NEW')} />
          <InputFootnote class={this.codeError ? 'error' : ''}>{this.codeError ? this.$t('PAGE.MEMBERS.CREATE.ERROR.INVALID_QR_CODE.TITLE') : null}</InputFootnote>
        </div>

        <div class='btn-row' slot='footer'>
          <Button class='cancel-btn' type='outline' label={this.$t('CANCEL')} click={this.showHideCodeForm} ref='cancelBtn' />
          <Button class='save-btn' type='elevated' label={this.$t('SAVE')} click={this.assign} ref='saveBtn' />
        </div>
      </Modal>
    </div>
  }

  renderActionButtons (h: CreateElement) {
    return <div class='btn-row' slot='bottom'>
      <Button class='print-qr' type='remove' click={this.printQR} ref='printQrBtn' icon={'util/print'} label={this.$t('PRINT')} />
      <Button type='elevated' label={this.$t('PAGE.MEMBERS.QR_CODE.ASSIGN')} click={this.showHideCodeForm} ref='assignBtn' />
    </div>
  }
}
